import { requireAuth } from '@/router/helpers'

/**
 * FE routes
 */
const FeRoutes = [
  // {
  //   'path': '/polls',
  //   name: 'PollsIndex',
  //   component: () => import('./../pages/Index'),
  //   beforeEnter: requireAuth,
  //   meta: {
  //     isAdmin: true
  //   }
  // },
  // {
  //   'path': '/poll/:id',
  //   name: 'PollsView',
  //   component: () => import('./../pages/View'),
  //   beforeEnter: requireAuth,
  //   meta: {
  //     isAdmin: true
  //   }
  // }
]

/**
 * Admin routes
 */

const AdminRoutes = [
  {
    path: '/admin/polls',
    name: 'AdminPollsIndex',
    component: () => import('./../pages/admin/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true
    }
  },
  {
    path: '/admin/polls/:id/results',
    name: 'AdminPollsResults',
    component: () => import('./../pages/admin/Results'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true
    }
  },
  {
    path: '/admin/polls/create',
    name: 'AdminPollsCreate',
    components: {
      default: () => import('./../pages/admin/Index'),
      panel: () => import('./../pages/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: true, openPanel: true },
  },
  {
    path: '/admin/poll/:id/edit',
    name: 'AdminPollsEdit',
    components: {
      default: () => import('./../pages/admin/Index'),
      panel: () => import('./../pages/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: true, openPanel: true },
  },
  {
    path: '/admin/poll/:id/view',
    name: 'AdminPollsView',
    component: () => import('./../pages/admin/View'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  }
]

export default [...FeRoutes, ...AdminRoutes]